import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { translate } from '../../../base/i18n/functions';
import { updateSettings } from '../../../base/settings/actions';
import { shouldHideShareAudioHelper } from '../../../base/settings/functions.web';
import { toggleScreensharing } from '../../../base/tracks/mhActions';
import Checkbox from '../../../base/ui/components/web/Checkbox';
import Dialog from '../../../base/dialog/components/web/Dialog';
const useStyles = makeStyles()(() => {
    return {
        shareAudioDialog: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px 0',
            gap: '16px',
            color: '#000000', // Match old Dialog textStyles
        },
        shareAudioAnimation: {
            maxWidth: '100%',
            maxHeight: '300px',
            height: 'auto',
            borderRadius: '8px',
            objectFit: 'contain',
        },
        checkboxContainer: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '4px',
            color: '#000000',
        },
    };
});
/**
 * Component that displays the audio screen share helper dialog.
 */
const ShareAudioDialog = ({ _shouldHideShareAudioHelper, dispatch }) => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    /**
     * Continue the normal screen sharing flow when the user clicks continue.
     *
     * @returns {boolean}
     */
    const onContinue = useCallback(() => {
        // Pass undefined as the first parameter so the underlying logic decides weather or not to stop screen sharing.
        dispatch(toggleScreensharing(undefined, true));
        return true;
    }, [dispatch]);
    /**
     * Callback invoked when the hide audio helper checkbox has been selected. This setting will be persisted in
     * the local storage, thus the dialog won't be displayed again.
     *
     * @param {Object} e - The key event to handle.
     * @returns {void}
     */
    const onSelectHideShareAudioHelper = useCallback(({ target: { checked } }) => {
        dispatch(updateSettings({ hideShareAudioHelper: checked }));
    }, [dispatch]);
    return (React.createElement(Dialog, { ok: { translationKey: 'dialog.shareAudio' }, onSubmit: onContinue, size: 'large', titleKey: t('dialog.shareAudioTitle') },
        React.createElement("div", { className: classes.shareAudioDialog },
            React.createElement("video", { autoPlay: true, className: classes.shareAudioAnimation, loop: true, muted: true, playsInline: true, src: 'images/share-audio.mp4', tabIndex: 0 }),
            React.createElement("div", { className: classes.checkboxContainer },
                React.createElement(Checkbox, { checked: _shouldHideShareAudioHelper, label: t('dialog.hideShareAudioHelper'), labelColor: '#000000', name: 'hide-share-audio-helper', onChange: onSelectHideShareAudioHelper })))));
};
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {IReduxState} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    return {
        _shouldHideShareAudioHelper: Boolean(shouldHideShareAudioHelper(state))
    };
}
export default translate(connect(_mapStateToProps)(ShareAudioDialog));
